export const get = (obj, path, defaultValue = undefined) => {
  const keys = path.split('.');
  let value = obj;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return defaultValue;
    }
  }
  
  return value;
}

export const getCookieValue = (cookieName) => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export const deleteCookie = (cookieName) => {
  const host = window.location.hostname;
  const baseDomain = host.includes('.') ? `.${host.split('.').slice(-2).join('.')}` : host;

  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${baseDomain}`;
}



export const setCookie = (key, value, expirationMinutes = 1) => {
  const cookieName = key
  const cookieValue = value

  const expirationDate = new Date()
  expirationDate.setTime(expirationDate.getTime() + expirationMinutes * 60 * 1000)
  const expires = `expires=${expirationDate.toUTCString()}`
  const host = window.location.hostname;
  const baseDomain = host.includes('.') ? `.${host.split('.').slice(-2).join('.')}` : host;

  document.cookie = `${cookieName}=${cookieValue}; ${expires}; path=/; domain=${baseDomain}; Secure; SameSite=None`
}

export function transformGooglePlacesResult(googlePlacesResult, street1) {
  if(!googlePlacesResult) return

  const addressComponents = googlePlacesResult.address_components;

  // Helper function to find components by type
  const getComponent = (type) => {
    const component = addressComponents.find((c) => c.types.includes(type));
    return component ? component.long_name : "";
  };

  // Build the custom structure
  return {
      street1: street1 ?? getComponent('subpremise'), // Use 'subpremise' for apartments if present
      street2: `${getComponent('premise')} ${getComponent('route') || ''}`.trim(), // Combines "premise" and "route"
      city: getComponent('locality'), // City name
      country: getComponent('country'), // Country code
      state: getComponent('administrative_area_level_1'), // Full state name
      postal: getComponent('postal_code') || "", // Postal code
  };
}